import {FlashMessage} from "@shared/partials/flash-message/flash-message.models";

export default interface IflashMessageData{
  [key:string]: FlashMessage
}

export const flashMessageData: IflashMessageData = {
  emailSent : {
    color: 'warning',
    title: 'Email di conferma inviata',
    text: `Ti abbiamo inviato una email di conferma. <strong>Per favore clicca sul link presente nell'email.</strong> <br>
    (Questo passaggio è necessario per assicurarci che l'indirizzo email con cui ti sei registrato sia di tua proprietà.)<br>
    Se non vedi la nostra email di conferma nella tua posta in ingresso, <strong>controlla che non sia finita SPAM.</strong>
    `
  },
  emailVerified: {
    color: 'success',
    title: 'Verifica email completata',
    text: 'La tua email è confermata. Ora puoi accedere con le tue credenziali'
  },
  emailConfirmProgress:{
    color: 'warning',
    title: 'Validazione email in corso',
    text: 'Stiamo verificando la tua email, per favore non chiudere questa pagina'
  },
  emailConfirmError:{
    color: 'danger',
    title: 'Non riusciamo a confermare la tu email',
    text: 'Riprova tra qualche minuto o prova a contattarci tramite il form nella pagina contatti'
  },
  emailAlreadyActivated:{
    color: 'danger',
    title: 'Email NON confermata',
    text: 'Questa email era stata confermata in precedenza. Il tuo account dovrebbe risultare già attivo'
  },
  emailContactSuccess:{
    color: 'success',
    title: 'Messaggio inviato',
    text: 'Il tuo messaggio è stato inviato'
  },
  passwordRecoverySuccess:{
    color: 'success',
    title: 'Password è aggiornata',
    text: 'Puoi accedere con la tua password. La vecchia password non è piu valida'
  },
  redeemSuccess:{
    color: 'success',
    title: 'Premio ottenuto',
    text: 'Ti abbiamo inviato un email con il tuo premio all\'inidirizzo da te scelto'
  },
  redeemError:{
    color: 'danger',
    title: 'Errore nel ottenimento del premio',
    text : 'Ci dispiace, c\'è stato un errore nella procedura di richiesta del premio. Riprova piu tardi o contattaci attraverso la pagina contatti',
  },
  emailChangeSuccess: {
    color: 'success',
    title: 'Email Aggiornata',
    text: 'La tua email è stata correttamente cambiata. Utilizza la tua nuova email e la tua password per accedere a Pollstar.'
  },
  emailChangeFailure: {
    color: 'danger',
    title: 'Email non aggiornata',
    text: 'Riprova tra qualche minuto o prova a contattarci tramite il form nella pagina contatti'
  }
}




